import React, { useCallback, useEffect, useState } from 'react';
import FeedbackModalContent from './FeedbackModalContent';
import TrueImpactModal, {
  modalHeightAutoStyles,
} from 'shared/design-system/components/TrueImpactModal';
import { useGraphQLRequest } from 'shared/auth/hooks/useApiRequest';
import { saveReportRating } from './api';
import { useClient } from 'shared/apollo';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { setRatingSessionStorage } from '../utils';

interface FeedbackModalProps {
  open: boolean;
  isDebug: boolean;
  className?: string;
  reportId: number | string;
  handleClose: () => unknown;
  handleDisableFeedback: () => unknown;
}

const addStyles = `.modal-header { border-bottom: 1px solid ${COLORS.ctaPrimaryBackground}; background-color: ${COLORS.greyLightest}; } ` +
  `.modal-wrapper .modal-content { background-color: ${COLORS.whiteBase} } .modal-wrapper .modal-footer { ` +
  `background-color: ${COLORS.greyLightest}; }`;
const FeedbackModal: React.FC<FeedbackModalProps> = ({
  open,
  isDebug,
  reportId,
  className,
  handleClose,
  handleDisableFeedback,
}) => {
  const client = useClient();
  const [requestState, makeRequest] = useGraphQLRequest<unknown>();
  const [rating, setRating] = useState<number>(0);
  const [feedback, setFeedback] = useState<string>('');

  useEffect(() => {
    if (requestState.type === 'REQUEST_SUCCESS') {
      handleClose();
      handleDisableFeedback();
      setRatingSessionStorage(reportId);
    }
  }, [requestState.type]);

  const handleSubmit = useCallback(() => {
    if (!client) return;
    makeRequest(
      saveReportRating(client, { reportId, rating, description: feedback }),
    );
  }, [rating, feedback, handleClose, handleDisableFeedback]);

  const isLoading = requestState.type === 'REQUEST_START';

  return (
    <TrueImpactModal
      open={open}
      maxWidth="900px"
      maxHeight="800px"
      hideHeader={true}
      onClose={handleClose}
      showExpandButton={true}
      addStyles={addStyles + modalHeightAutoStyles}
      previous={
        isDebug
          ? {
              onClick: handleClose,
              text: 'Cancel',
              disabled: isLoading,
            }
          : undefined
      }
      next={{
        disabled: !rating,
        isLoading,
        text: 'Submit Feedback',
        onClick: handleSubmit,
      }}
    >
      <FeedbackModalContent
        rating={rating}
        isDebug={isDebug}
        feedback={feedback}
        className={className}
        handleRating={setRating}
        handleSubmit={handleSubmit}
        handleFeedback={setFeedback}
      />
    </TrueImpactModal>
  );
};

export default FeedbackModal;
